/* eslint-disable prettier/prettier */
import { MerchantType } from './merchant-types';

export type CustomerSegment = typeof customerSegments[number];
export const customerSegments = [
  'MANUFACTURER_OR_IMPORTER_AS_TAX_WAREHOUSE',
  'MANUFACTURER_OR_IMPORTER_AS_SIMPLIFIED_TAX_WAREHOUSE',
  'MANUFACTURER_OR_IMPORTER_AS_SMALL_SCALE_WINE_PRODUCER',
  'INTERNATIONAL_TRADER_AS_REGISTERED_DEALER',
  'INTERNATIONAL_TRADER_AS_COMMUNITY_EXCISE_WHOLESALER',
  'INTERNATIONAL_TRADER_AS_EXPORT_IMPORT_WHOLESALER',
  'WHOLESALER_AS_IS',
  'RETAILER_AS_HOTEL',
  'RETAILER_AS_RESTAURANT',
  'RETAILER_AS_CAFE',
  'RETAILER_AS_RETAIL_CHAIN',
  'RETAILER_AS_TRAFIK',
  'RETAILER_AS_OTHER_RETAILER',
  'END_CONSUMER_AS_IS',
];

type MerchantTypeToCustomerSegment = Record<
  MerchantType,
  Array<CustomerSegment>
>;
export const merchantTypeToCustomerSegment: MerchantTypeToCustomerSegment = {
  MANUFACTURER_OR_IMPORTER_AS_TAX_WAREHOUSE: [
    'MANUFACTURER_OR_IMPORTER_AS_TAX_WAREHOUSE',
    'MANUFACTURER_OR_IMPORTER_AS_SIMPLIFIED_TAX_WAREHOUSE',
    'INTERNATIONAL_TRADER_AS_COMMUNITY_EXCISE_WHOLESALER',
    'INTERNATIONAL_TRADER_AS_EXPORT_IMPORT_WHOLESALER',
    'WHOLESALER_AS_IS',
    'RETAILER_AS_HOTEL',
    'RETAILER_AS_RESTAURANT',
    'RETAILER_AS_CAFE',
    'RETAILER_AS_RETAIL_CHAIN',
    'RETAILER_AS_TRAFIK',
    'RETAILER_AS_OTHER_RETAILER',
    'END_CONSUMER_AS_IS',
  ],
  MANUFACTURER_OR_IMPORTER_AS_SIMPLIFIED_TAX_WAREHOUSE: [
    'MANUFACTURER_OR_IMPORTER_AS_TAX_WAREHOUSE',
    'MANUFACTURER_OR_IMPORTER_AS_SIMPLIFIED_TAX_WAREHOUSE',
    'INTERNATIONAL_TRADER_AS_COMMUNITY_EXCISE_WHOLESALER',
    'INTERNATIONAL_TRADER_AS_EXPORT_IMPORT_WHOLESALER',
    'WHOLESALER_AS_IS',
    'RETAILER_AS_HOTEL',
    'RETAILER_AS_RESTAURANT',
    'RETAILER_AS_CAFE',
    'RETAILER_AS_RETAIL_CHAIN',
    'RETAILER_AS_TRAFIK',
    'RETAILER_AS_OTHER_RETAILER',
    'END_CONSUMER_AS_IS',
  ],
  MANUFACTURER_OR_IMPORTER_AS_SMALL_SCALE_WINE_PRODUCER: [
    'MANUFACTURER_OR_IMPORTER_AS_TAX_WAREHOUSE',
    'MANUFACTURER_OR_IMPORTER_AS_SIMPLIFIED_TAX_WAREHOUSE',
    'INTERNATIONAL_TRADER_AS_COMMUNITY_EXCISE_WHOLESALER',
    'INTERNATIONAL_TRADER_AS_EXPORT_IMPORT_WHOLESALER',
    'WHOLESALER_AS_IS',
    'RETAILER_AS_HOTEL',
    'RETAILER_AS_RESTAURANT',
    'RETAILER_AS_CAFE',
    'RETAILER_AS_RETAIL_CHAIN',
    'RETAILER_AS_TRAFIK',
    'RETAILER_AS_OTHER_RETAILER',
    'END_CONSUMER_AS_IS',
  ],
  INTERNATIONAL_TRADER_AS_REGISTERED_DEALER: [
    'INTERNATIONAL_TRADER_AS_COMMUNITY_EXCISE_WHOLESALER',
    'INTERNATIONAL_TRADER_AS_EXPORT_IMPORT_WHOLESALER',
    'WHOLESALER_AS_IS',
    'RETAILER_AS_HOTEL',
    'RETAILER_AS_RESTAURANT',
    'RETAILER_AS_CAFE',
    'RETAILER_AS_RETAIL_CHAIN',
    'RETAILER_AS_TRAFIK',
    'RETAILER_AS_OTHER_RETAILER',
  ],
  INTERNATIONAL_TRADER_AS_COMMUNITY_EXCISE_WHOLESALER: [
    'INTERNATIONAL_TRADER_AS_COMMUNITY_EXCISE_WHOLESALER',
    'INTERNATIONAL_TRADER_AS_EXPORT_IMPORT_WHOLESALER',
    'WHOLESALER_AS_IS',
    'RETAILER_AS_HOTEL',
    'RETAILER_AS_RESTAURANT',
    'RETAILER_AS_CAFE',
    'RETAILER_AS_RETAIL_CHAIN',
    'RETAILER_AS_TRAFIK',
    'RETAILER_AS_OTHER_RETAILER',
    'END_CONSUMER_AS_IS',
  ],
  INTERNATIONAL_TRADER_AS_EXPORT_IMPORT_WHOLESALER: [
    'INTERNATIONAL_TRADER_AS_COMMUNITY_EXCISE_WHOLESALER',
    'INTERNATIONAL_TRADER_AS_EXPORT_IMPORT_WHOLESALER',
    'WHOLESALER_AS_IS',
    'RETAILER_AS_HOTEL',
    'RETAILER_AS_RESTAURANT',
    'RETAILER_AS_CAFE',
    'RETAILER_AS_RETAIL_CHAIN',
    'RETAILER_AS_TRAFIK',
    'RETAILER_AS_OTHER_RETAILER',
    'END_CONSUMER_AS_IS',
  ],
  WHOLESALER_AS_IS: [
    'INTERNATIONAL_TRADER_AS_COMMUNITY_EXCISE_WHOLESALER',
    'INTERNATIONAL_TRADER_AS_EXPORT_IMPORT_WHOLESALER',
    'WHOLESALER_AS_IS',
    'RETAILER_AS_HOTEL',
    'RETAILER_AS_RESTAURANT',
    'RETAILER_AS_CAFE',
    'RETAILER_AS_RETAIL_CHAIN',
    'RETAILER_AS_TRAFIK',
    'RETAILER_AS_OTHER_RETAILER',
    'END_CONSUMER_AS_IS',
  ],

  RETAILER_AS_HOTEL: ['END_CONSUMER_AS_IS'],
  RETAILER_AS_RESTAURANT: ['END_CONSUMER_AS_IS'],
  RETAILER_AS_CAFE: ['END_CONSUMER_AS_IS'],
  RETAILER_AS_RETAIL_CHAIN: ['END_CONSUMER_AS_IS'],
  RETAILER_AS_TRAFIK: ['END_CONSUMER_AS_IS'],
  RETAILER_AS_OTHER_RETAILER: ['END_CONSUMER_AS_IS'],
};
